import { Routes } from '@angular/router';
import { internalRoutes } from './app/layouts/internal/internal.routes';
import { externalRoutes } from './app/layouts/external/external.routes';

export const routes: Routes = [...internalRoutes, ...externalRoutes];
